import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import Icon from '../Icon';

import styles from './Checkbox.module.scss';

const Checkbox = (props) => {
  return (
    <FormControlLabel
      classes={{
        root: styles['MuiFormControlLabel-root'],
        label: styles['MuiFormControlLabel-label'],
      }}
      {...props}
      control={
        <MuiCheckbox
          classes={{ root: styles['MuiFormControlLabel-root'] }}
          icon={
            <Icon
              id="checkbox-frame"
              viewBox="0 0 20 20"
              sx={{
                width: '20px',
                height: '20px',
              }}
            />
          }
          checkedIcon={
            <Icon
              id="checkbox-checked"
              viewBox="0 0 20 20"
              sx={{
                width: '20px',
                height: '20px',
              }}
            />
          }
        />
      }
    />
  );
};

export default Checkbox;
